import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import {
	postInventaireCategorie,
	postInventaireCategorieReset,
	deleteInventaireCategorie,
	deleteInventaireCategorieReset,
} from "../../../store/actions/atelierInventaireActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import CustomModal from "../../basics/interface/CustomModal"

// Édition d'une catégorie d'inventaire (modal V2). POST/DELETE renvoient la
// liste fraîche → le reducer met la table à jour seul. ⚠️ La suppression
// CASCADE supprime aussi les articles de la catégorie.
const CategorieModalV2 = ({ categorie, onClose }) => {
	const dispatch = useDispatch()
	const postState = useSelector((s) => s.atelierInventaire.postCategorie)
	const deleteState = useSelector((s) => s.atelierInventaire.deleteCategorie)
	const isCreate = !categorie.id
	const [confirmDelete, setConfirmDelete] = useState(false)
	const [nom, setNom] = useState(categorie.nom || "")

	useEffect(() => {
		if (!postState.saved && !deleteState.deleted) return
		const t = setTimeout(() => {
			dispatch(postInventaireCategorieReset())
			dispatch(deleteInventaireCategorieReset())
			onClose()
		}, 800)
		return () => clearTimeout(t)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [postState.saved, deleteState.deleted])

	useEffect(
		() => () => {
			dispatch(postInventaireCategorieReset())
			dispatch(deleteInventaireCategorieReset())
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	)

	const invalid = !nom.trim()

	const save = () =>
		dispatch(
			postInventaireCategorie(
				JSON.stringify({ id: categorie.id || null, nom: nom.trim() }),
			),
		)
	const remove = () => {
		if (!confirmDelete) {
			setConfirmDelete(true)
			return
		}
		dispatch(
			deleteInventaireCategorie(JSON.stringify({ id: categorie.id })),
		)
	}

	const busy =
		postState.saving ||
		postState.saved ||
		deleteState.deleting ||
		deleteState.deleted

	const buttons = []
	if (!isCreate) {
		buttons.push({
			title: deleteState.deleting ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : confirmDelete ? (
				"Confirmer ? (+ articles)"
			) : (
				"Supprimer"
			),
			styleName: "danger",
			onClick: remove,
			disabled: busy,
		})
	}
	buttons.push({
		title: "Annuler",
		styleName: "secondary",
		onClick: onClose,
		disabled: busy,
	})
	buttons.push({
		title: postState.saving ? (
			<FontAwesomeIcon icon={faSync} spin />
		) : postState.saved ? (
			<FontAwesomeIcon icon={faCheck} />
		) : (
			"Enregistrer"
		),
		styleName: "primary",
		onClick: save,
		disabled: busy || invalid,
	})

	return (
		<CustomModal
			title={isCreate ? "Nouvelle catégorie" : "Éditer la catégorie"}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={buttons}
		>
			<div style={gs.fieldGroup}>
				<div style={gs.fieldRow}>
					<label style={gs.label}>
						Nom<span style={{ color: COLORS.danger }}> *</span>
					</label>
					<input
						style={gs.input}
						value={nom}
						onChange={(e) => setNom(e.target.value)}
						autoFocus
					/>
				</div>
			</div>
		</CustomModal>
	)
}

export default CategorieModalV2
